// extracted by mini-css-extract-plugin
export default {"page":"K1-z","cartModal":"L1-z","checkout":"M1-z","placeholder":"N1-z","account":"O1-z"};